export default __webpack_public_path__ + "static/media/icons_arrow-left-white.49957ab5.svg";